define("shared/helpers/is-present", ["exports", "@ember/component/helper", "@ember/utils"], function (_exports, _helper, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"@ember/utils"eaimeta@70e063a35619d71f
  class IsPresent extends _helper.default {
    compute(params) {
      return (0, _utils.isPresent)(params[0]);
    }
  }
  _exports.default = IsPresent;
});